<ng-container>
  <div class="mb-6 page-padding-x">
    <div class="flex flex-row items-center justify-between">
      <div class="flex items-center">
        <h2>Project Updates</h2>
      </div>
      <div
        class="flex flex-row justify-end items-center gap-6 [&>div:not(:first-child)]:border-l-2"
      >
        <div
          *ngFor="let phase of expectedPhases"
          class="flex flex-row items-center gap-3 px-3 border-black border-solid"
          [id]="'phase-count-' + phase.replaceAll(' ', '')"
        >
          <ng-container>
            <div class="text-5xl font-bold" name="count">
              {{ getProjectsByPhase(phase) }}
            </div>
            <div class="text-gray-400" name="label" aria-disabled="true">
              Projects in <br />
              {{ phase }}
            </div>
          </ng-container>
        </div>
        <a
          class="btn btn-primary "
          [routerLink]="['/projects']"
          [queryParams]="{view: myProjects}"
          id="btn-view-projects"
        >
          {{ viewProjectsButtonLabel }}
        </a>
      </div>
    </div>
  </div>



  <ng-container>

    <div *ngIf="loading" class="flex justify-center">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="50">
      </mat-progress-spinner>
    </div>

    <app-update-scroller *ngIf="!loading && projects"
      [title]="'New Updates'"
      [updateCount]="projects.length"
      id="scroller-project-updates"
    >
      <a
        *ngFor="let project of projects"
        [routerLink]="['/projects', project.projectId]"
        [id]="'card-project-updates-' + project.projectId"
      >
        <app-update-scroller-card
          [title]="project.title"
          [description]="project.description"
        >
          <div headerLeft name="date">
            {{ project.date | dateFormat }}
          </div>
          <app-status-badge
            [colourScheme]="statusBadgeColourSchemeEnum.Green"
            headerRight
            name="phase-{{ project.projectId }}"
          >
            {{ project.phase }}
          </app-status-badge>
        </app-update-scroller-card>
      </a>



    </app-update-scroller>
    <div *ngIf="!loading && projects?.length == 0" class="p-5 ml-10 font-bold bg-white rounded-lg page-padding-s w-80 shadow-cardShadow h-36 card-size">
        There are no new updates for your projects at this time.
    </div>
  </ng-container>
</ng-container>
